import type { AppTranslations, I18nProvider } from '@web-chat-core/ui-kit/lib/i18n/provider';
import defaultTranslations from './locales/lang.json';

const mergeTranslations = (base: AppTranslations, overlay?: AppTranslations): AppTranslations => ({
    en: {
        ...base.en,
        ...(overlay?.en ?? {}),
    },
    ru: {
        ...base.ru,
        ...(overlay?.ru ?? {}),
    },
});

// В тестах темы нет: без этой проверки require ищет lang.undefined.json.
// В сборке REACT_APP_THEME — литерал прямо в шаблоне, webpack берёт один lang.<theme>.json.
// Локальная переменная вместо process.env.REACT_APP_THEME собирает все lang.*.json.
const loadBrandOverlay = (): AppTranslations | undefined => {
    if (!process.env.REACT_APP_THEME) {
        return undefined;
    }
    return require(`./locales/lang.${process.env.REACT_APP_THEME}.json`) as AppTranslations;
};

const provider: I18nProvider = {
    getTranslations: () => mergeTranslations(defaultTranslations as AppTranslations, loadBrandOverlay()),
    getFallbackLng: () => 'en',
};

export default provider;
